module.exports = __webpack_public_path__ + "static/media/usmanCV_1.3ec9d3dc.png";